import React from "react";
import {
  HeroContentHubBase,
  HeroTitle,
  HeroDescription,
  HeroContent,
  NewsletterContainer,
  HeroImage,
} from "./hero-content-hub.styled";
import { ContentHubFragment } from "../../types/graphql";
import { NewsletterForm } from "../newsletter-form/newsletter-form";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";

interface IHeroContentHubProps {
  heroContentHub: ContentHubFragment;
}

const HeroContentHub = (props: IHeroContentHubProps) => {
  const heroContentHub = props.heroContentHub.data;
  return (
    (heroContentHub && (
      <HeroContentHubBase>
        <HeroImage
          image={heroContentHub.content_hub_image?.gatsbyImageData}
          alt={heroContentHub.content_hub_image?.alt || "Xometry Resources"}
        />
        <HeroContent>
          {heroContentHub.content_hub_name && (
            <HeroTitle>{heroContentHub.content_hub_name}</HeroTitle>
          )}
          {heroContentHub.content_hub_description && (
            <HeroDescription>
              <PrismicRichText
                field={heroContentHub.content_hub_description.richText}
                components={htmlSerializer}
              />
            </HeroDescription>
          )}
          <NewsletterContainer>
            <NewsletterForm
              ctaKind="primary"
              ctaScale="xlarge"
              eventPageSection="hero-content-hub"
              inputScale="xlarge"
              alignment="start"
            />
          </NewsletterContainer>
        </HeroContent>
      </HeroContentHubBase>
    )) || <></>
  );
};

export default HeroContentHub;
